import { apiClient } from 'lib/api';
import type { UserEntry } from './types';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';

export const getMe = async ({ signal }: QueryFunctionContext<[string]>): Promise<UserEntry> => {
  const res = await apiClient.get<UserEntry>(`/users/me`, {
    signal,
  });

  return res.data;
};

export const useMeOptions = queryOptions({
  staleTime: 60 * 180 * 1000,
  queryFn: getMe,
  queryKey: ['me'],
});
